import context from "@helpers/context";

const [
    ClubEditContext, 
    useClubEditContext
] = context<Club.Contexts.ClubEdit>()

export default ClubEditContext
export { useClubEditContext }